import { useQuery } from '@apollo/client';
import { GET_STAGE_TASK_DETAILS } from '@frontend/app/queries/GetCustomStageTaskDetails';
import type {
  CustomStageTaskDetailsQuery,
  CustomStageTaskDetailsQueryVariables
} from '@frontend/app/queries/types/CustomStageTaskDetailsQuery';

interface UseGetCustomStageTaskDetailsProps {
  programId: number;
  stageId: number;
  memberId: number;
  skip?: boolean;
}

export const useGetCustomStageTaskDetails = ({
  programId,
  stageId,
  memberId,
  skip = false
}: UseGetCustomStageTaskDetailsProps) => {
  const { data, loading, error, refetch } = useQuery<
    CustomStageTaskDetailsQuery,
    CustomStageTaskDetailsQueryVariables
  >(GET_STAGE_TASK_DETAILS, {
    variables: {
      programId,
      stageId,
      memberId
    },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  return {
    stageTaskDetails: data?.getStageTaskDetails,
    loading,
    error,
    refetch
  };
};
